const getISTDate = () => {
    const date = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000; // IST = UTC + 5:30
    const istDate = new Date(date.getTime() + istOffset);
    return istDate.toISOString().split('T')[0];
};

export default getISTDate;